export const firstCol = {
    textAlign: "right",
    marginLeft: "3%",
    marginTop: "2px"
}

export const containerStyle = {
    color: "white"
}
